(function(){
  function rewriteRule(rule){
    if (rule.cssRules){
      for (var i=0;i<rule.cssRules.length;i++){ rewriteRule(rule.cssRules[i]); }
      return;
    }
    if (!rule.style) return;
    var sel = rule.selectorText || '';
    var cssText = rule.style.cssText;
    if (!cssText) return;
    var changed = false;
    if (/1b8a9c/i.test(cssText)){
      cssText = cssText.replace(/#1b8a9c/gi, '#009BA4');
      changed = true;
    }
    if (/montserrat/i.test(cssText)){
      cssText = cssText.replace(/montserrat/gi, 'Open Sans');
      changed = true;
    }
    if (/e8720c/i.test(cssText) && /tt-newsletter/i.test(sel) && sel.indexOf('.btn') > -1 && sel.indexOf(':hover') === -1){
      cssText = cssText.replace(/#e8720c/gi, '#009BA4');
      changed = true;
    }
    if (changed){
      try { rule.style.cssText = cssText; } catch(e){}
    }
  }
  function run(){
    var sheets = document.styleSheets;
    for (var s=0; s<sheets.length; s++){
      var rules;
      try { rules = sheets[s].cssRules; } catch(e){ continue; }
      if (!rules) continue;
      try {
        for (var r=0;r<rules.length;r++){ rewriteRule(rules[r]); }
      } catch(e){ /* ignore cross-origin or parse issues */ }
    }
  }
  run();
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  }
  window.addEventListener('load', run);
})();
